export const MQ_XS = 'XS';
export const MQ_S = 'S';
export const MQ_M = 'M';
export const MQ_L = 'L';
export const MQ_XL = 'XL';
export const MQ_XXL = 'XXL';
